import React from 'react';
import map from 'lodash/map';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Divider, IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = () =>
  createStyles({
    button: {
      background: 'transparent !important',
    },
  });

interface IconMenuActionsComponentProps extends WithStyles<typeof styles> {
  actions: Record<string, unknown>;
  onAction: Function;
  style: Record<string, unknown>;
}

interface IconMenuActionsComponentState {
  anchorEl: HTMLElement | null;
}

class IconMenuActionsComponent extends React.PureComponent<
  IconMenuActionsComponentProps,
  IconMenuActionsComponentState
> {
  constructor(props: IconMenuActionsComponentProps) {
    super(props);

    this.renderAction = this.renderAction.bind(this);
    this.handleIconButtonClick = this.handleIconButtonClick.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      anchorEl: null,
    };
  }

  handleIconButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.stopPropagation();
    this.setState({ anchorEl: null });
  }

  render() {
    const { style, actions } = this.props;
    const { anchorEl } = this.state;
    return (
      <>
        {this.renderIconButtonElement()}
        <Menu style={style} anchorEl={anchorEl} open={!!anchorEl} onClose={this.handleClose} disableAutoFocusItem>
          {map(actions, this.renderAction)}
        </Menu>
      </>
    );
  }

  renderIconButtonElement() {
    const { classes } = this.props;

    return (
      <IconButton className={classes.button} disableRipple disableTouchRipple onClick={this.handleIconButtonClick}>
        <MoreVertIcon color="primary" />
      </IconButton>
    );
  }

  renderAction(label: string, key: string) {
    const { onAction } = this.props;

    if (key === 'divider') return <Divider key="divider" />;

    return (
      <MenuItem
        key={key}
        onClick={(e) => {
          e.stopPropagation();
          onAction(key);
        }}
      >
        {label}
      </MenuItem>
    );
  }
}

export const IconMenuActions = withStyles(styles)(IconMenuActionsComponent);
